import * as React from "react";
const SvgFiRrPancakes = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-pancakes_svg__a)">
      <path
        fill="#062147"
        d="M5.807 8.411A1.5 1.5 0 0 1 7 9.876V19a1 1 0 1 0 2 0v-8.516c0-.827.673-1.5 1.5-1.5s1.5.673 1.5 1.5V14a1 1 0 1 0 2 0v-3.672c0-.774.573-1.414 1.334-1.488C17.366 8.641 24 7.741 24 4.501c0-3.092-6.221-4.5-12-4.5S0 1.408 0 4.5c0 1.748 2.062 3.137 5.807 3.911M12 2c6.598 0 10 1.752 10 2.5 0 .494-1.975 1.871-6.861 2.349a3.46 3.46 0 0 0-2.224 1.112 3.48 3.48 0 0 0-2.414-.977c-.841 0-1.603.31-2.207.806a3.48 3.48 0 0 0-2.081-1.337C3.062 5.801 2.001 4.839 2.001 4.5c0-.748 3.402-2.5 10-2.5zm11.91 18.415C22.78 22.892 17.114 24 12 24S1.22 22.892.09 20.415a1 1 0 1 1 1.82-.83C2.372 20.598 6.135 22 12 22s9.628-1.402 10.09-2.415a1 1 0 1 1 1.82.83m0-5C22.78 17.892 17.114 19 12 19a1 1 0 1 1 0-2c5.865 0 9.628-1.402 10.09-2.415a1 1 0 1 1 1.82.83M4.95 17.24a1 1 0 0 1-1.261.64c-1.931-.631-3.142-1.46-3.6-2.465a1 1 0 1 1 1.82-.829c.15.33.869.893 2.4 1.393a1 1 0 0 1 .641 1.261m18.465-8.15a1 1 0 0 1 .495 1.325c-.909 1.995-4.621 2.861-6.753 3.2-.054.008-.983.157-1.145-.831a1 1 0 0 1 .83-1.145c3.677-.583 5.04-1.598 5.247-2.053a1 1 0 0 1 1.325-.496zM4.95 12.24a1 1 0 0 1-1.261.64c-1.931-.631-3.142-1.46-3.6-2.465a1 1 0 0 1 1.82-.829c.15.33.869.893 2.4 1.393a1 1 0 0 1 .641 1.261"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-pancakes_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrPancakes;
